import { get, put, post, del, default as com } from "@/common/api";

const api = {
  queryReg: com.queryReg,
  delAppointment(id) {
    return del(`/api/op/reg/appointment/${id}`);
  },
  /** ****************** 患者 ****************** **/
  getPatientByIdNo: com.getPatientByIdNo,
  /****** 门诊 *******/
  queryTarget: para => {
    return get("/api/op/regTarget", para);
  },
  //查询有出诊的号别
  queryValidRegType: () => {
    return get("/api/op/regType/valid");
  },
  // 查询余号
  queryRestReg: para => {
    return get("/api/op/regStatistic/appointment", para);
  },
  //预约就诊号/op/reg/appointment
  lockReg: para => {
    return post("/api/op/reg/appointment", para);
  },
  
  // 查询处方
  queryRp: com.queryRp,
  // 查询付款记录
  getPayment: com.getPayment,
  //获取收费员当前发票号
  invoiceCurrent: com.invoiceCurrent,
  // get lodop print template
  getPrintTemplate: com.getPrintTemplate,
  // 取号
  takeRegNo: id => put(`/api/op/reg/${id}/take`),
};

export default api;
